import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
	currentIndex: number;
	total: number;
}

// Four visual segments that fill left-to-right as the user advances through the
// onboarding flow. Progress is driven by the screen's actual position
// (`(currentIndex + 1) / total`) so it starts near-empty on the first screen and
// reaches 100% on the last — instead of the previous hardcoded per-question map
// that always pre-filled a segment (made screen 1 look like the 2nd step).
// Screens skipped by branching just advance the fill a little faster.
export function ProgressBar({ currentIndex, total }: ProgressBarProps) {
	const totalSegments = 4;
	const safeTotal = Math.max(total, 1);
	const progress = Math.min(
		Math.max(((currentIndex + 1) / safeTotal) * 100, 0),
		100,
	);

	return (
		<div className={styles.container}>
			<div className={styles.segmentedProgressBar}>
				{Array.from({ length: totalSegments }).map((_, index) => {
					const segmentStart = (index / totalSegments) * 100;
					const segmentEnd = ((index + 1) / totalSegments) * 100;
					const isFilled = progress > segmentStart;
					const fillPercentage = isFilled
						? Math.min(
								((progress - segmentStart) / (segmentEnd - segmentStart)) * 100,
								100,
							)
						: 0;

					return (
						<div key={index} className={styles.segment}>
							<div className={styles.segmentBackground}>
								{fillPercentage > 0 && (
									<div
										className={styles.segmentFill}
										style={{ width: `${fillPercentage}%` }}
									/>
								)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
